import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FileText, ClipboardCheck, MessageSquare, Sparkles, Sun } from "lucide-react";

export default function CitizenDashboard() {
  const { user } = useAuth();
  const [apps, setApps] = useState([]);
  useEffect(() => { api.get("/applications").then((r)=>setApps(r.data.items)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">My Portal</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">Welcome, {user?.name?.split(" ")[0]}!</h1>
        <p className="mt-1 text-muted-foreground text-sm">Manage your applications, grievances and profile.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Link to="/services/solar_rooftop" className="rounded-xl border border-border bg-card p-5 hover:-translate-y-0.5 transition-transform">
          <div className="h-10 w-10 rounded-lg bg-amber-500/10 text-amber-500 grid place-items-center"><Sun className="h-5 w-5"/></div>
          <div className="mt-3 font-heading font-semibold">Apply Solar Rooftop</div>
          <div className="text-xs text-muted-foreground mt-0.5">Get subsidy up to ₹78,000</div>
        </Link>
        <Link to="/track" className="rounded-xl border border-border bg-card p-5 hover:-translate-y-0.5 transition-transform">
          <div className="h-10 w-10 rounded-lg bg-sky-500/10 text-sky-500 grid place-items-center"><FileText className="h-5 w-5"/></div>
          <div className="mt-3 font-heading font-semibold">Track Application</div>
          <div className="text-xs text-muted-foreground mt-0.5">Enter tracking ID</div>
        </Link>
        <Link to="/grievance" className="rounded-xl border border-border bg-card p-5 hover:-translate-y-0.5 transition-transform">
          <div className="h-10 w-10 rounded-lg bg-fuchsia-500/10 text-fuchsia-500 grid place-items-center"><MessageSquare className="h-5 w-5"/></div>
          <div className="mt-3 font-heading font-semibold">Register Grievance</div>
          <div className="text-xs text-muted-foreground mt-0.5">SLA-based resolution</div>
        </Link>
        <Link to="/rti" className="rounded-xl border border-border bg-card p-5 hover:-translate-y-0.5 transition-transform">
          <div className="h-10 w-10 rounded-lg bg-emerald-500/10 text-emerald-500 grid place-items-center"><ClipboardCheck className="h-5 w-5"/></div>
          <div className="mt-3 font-heading font-semibold">File RTI</div>
          <div className="text-xs text-muted-foreground mt-0.5">Right to Information</div>
        </Link>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6">
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="label-tiny">My Applications</div>
            <div className="font-heading font-semibold">Recent submissions</div>
          </div>
          <Link to="/services" className="btn-outline text-xs">New application</Link>
        </div>
        {apps.length === 0 ? (
          <div className="text-sm text-muted-foreground">No applications yet. <Link to="/services" className="text-[hsl(var(--primary))]">Start now</Link>.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="table-th">Tracking ID</th>
                  <th className="table-th">Scheme</th>
                  <th className="table-th">District</th>
                  <th className="table-th">Status</th>
                  <th className="table-th">Submitted</th>
                </tr>
              </thead>
              <tbody>
                {apps.map((a) => (
                  <tr key={a.id} className="border-t border-border">
                    <td className="table-cell font-mono">{a.tracking_id}</td>
                    <td className="table-cell capitalize">{a.scheme.replace("_"," ")}</td>
                    <td className="table-cell">{a.district}</td>
                    <td className="table-cell"><span className="badge-status-approved capitalize">{a.status.replace("_"," ")}</span></td>
                    <td className="table-cell text-muted-foreground">{new Date(a.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="rounded-2xl border border-[hsl(var(--primary))]/30 bg-[hsl(var(--primary))]/5 p-6">
        <div className="flex items-start gap-4">
          <div className="h-10 w-10 rounded-lg bg-[hsl(var(--primary))] text-white grid place-items-center"><Sparkles className="h-5 w-5"/></div>
          <div>
            <div className="font-heading font-semibold">Talk to PEDA AI Assistant</div>
            <div className="text-sm text-muted-foreground mt-1">Ask about schemes, subsidies, or the application process.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
